import { z } from 'zod';
/** Fixed event channels keep private text out of lock-screen notifications. */
export const PUSH_EVENTS = ['research_ready', 'digest_ready', 'test'];
/** Known browser push services only; arbitrary subscription URLs are an SSRF vector. */
export function isPushEndpoint(value) {
    try {
        const url = new URL(value);
        if (url.protocol !== 'https:' || url.port || url.username || url.password || url.hash)
            return false;
        const host = url.hostname;
        return (host === 'fcm.googleapis.com' ||
            host === 'updates.push.services.mozilla.com' ||
            host === 'web.push.apple.com' ||
            /^[a-z0-9-]+\.notify\.windows\.com$/u.test(host));
    }
    catch {
        return false;
    }
}
export const PushEndpointSchema = z
    .string()
    .max(2048)
    .refine(isPushEndpoint, 'unsupported push service');
export const PushPreferencesSchema = z
    .object({
    research_ready: z.boolean().default(true),
    digest_ready: z.boolean().default(false),
})
    .strict();
export const PushSubscriptionInputSchema = z
    .object({
    endpoint: PushEndpointSchema,
    keys: z
        .object({
        p256dh: z.string().regex(/^[A-Za-z0-9_-]{87}$/u),
        auth: z.string().regex(/^[A-Za-z0-9_-]{22}$/u),
    })
        .strict(),
    preferences: PushPreferencesSchema,
})
    .strict();
